import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { Subscription } from 'rxjs/Rx';
import { EntityLicenseModel } from '../../../model/entityLicenseModel';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { Router } from '@angular/router';
import { SeverEmploymentService } from '../sever-employment.service';
import { StorageService } from '../../../shared/security/StorageService';
import { SeverEmploymentRequestModel } from '../../../model/severEmploymentRequestModel';
import { SeverEmploymentResponseModel } from '../../../model/severEmploymentResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { MessageModel } from '../../../model/messageModel';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-sever-employment-notification',
  templateUrl: './sever-employment-notification.component.html',
  styleUrls: ['./sever-employment-notification.component.css']
})
export class SeverEmploymentNotificationComponent implements OnInit, OnDestroy{
  
  agree: boolean = false;
  submitAgree: boolean = false;
  startFunction: StartFunctionResponseModel = {};
  employmentInfoSubscription: Subscription;
  employmentInfo: EntityLicenseModel;
  severEmploymentRequest: SeverEmploymentRequestModel;
  severEmploymentResponse: SeverEmploymentResponseModel;
  workflow:WorkflowModel;
  userMessages: Array<MessageModel> = [];


  constructor(private startFunctionService: StartFunctionService,
    private router: Router,
    private severEmploymentService: SeverEmploymentService,
    private storageService: StorageService,
    private currentPageWatcher: CurrentPageWatcherService,private spinner: SpinnerService) {
    this.startFunction = this.storageService.getStartFunctionData();
    this.workflow=this.startFunction.Workflow;
  
    this.employmentInfoSubscription = this.severEmploymentService.getNotifySeverEmploymentInformation().subscribe(data => {
     this.employmentInfo = data;
     console.log("Employment Info in notification : " , this.employmentInfo);
  });


  }

  ngOnInit() {
    this.agree = false;
  }


  goBackHome() {
    this.router.navigate(['/home']).then(()=>{
      this.currentPageWatcher.sendUserMessages(null);
    });
  }

  agreePath(agreeForm) {
    this.currentPageWatcher.sendUserMessages(null);
    this.submitAgree = true;
    if (agreeForm && this.agree) {

      this.severEmploymentRequest = new SeverEmploymentRequestModel();
      this.severEmploymentRequest.WorkflowID = this.workflow.WorkflowID;
      this.severEmploymentRequest.CurrentStepIndex = this.workflow.CurrentStepIndex;

      this.severEmploymentService.submitSeverEmployment(this.severEmploymentRequest).subscribe(severEmploymentResp => {
        this.severEmploymentResponse = severEmploymentResp;
      
        if (this.severEmploymentResponse.UserMessages != undefined) {

          severEmploymentResp.UserMessages.forEach(el => {
              this.userMessages.push(el);
          });
        }
        //no error 
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        if (severEmploymentResp.Summary == 0) {
          this.router.navigate(['/severEmploymentReview']).then(() => {
            this.startFunctionService.getNotifyStepInProgress().emit(true);
            this.severEmploymentService.getNotifySelectedEmployer().emit(severEmploymentResp);
            this.severEmploymentService.getNotifySeverAgreement().emit(this.agree);
            this.severEmploymentService.getNotifySeverEmploymentInformation().emit(this.employmentInfo);
          });
          this.userMessages = [];

        }
        if (severEmploymentResp.Summary == 1){
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];
        }
        if (severEmploymentResp.Summary == 2) {
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      },
        (err) => {
          if (err.error && err.error.UserMessages != undefined) {
            err.error.UserMessages.forEach(element => {
              this.userMessages.push(element)
            });

          }
          else {
            let userMsg: MessageModel;
            userMsg.Alert = 3;
            userMsg.Description = err.message;
            this.userMessages.push(userMsg);

          }
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.currentPageWatcher.sendUserMessages(this.userMessages);
          this.spinner.hide();
        });
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.currentPageWatcher.sendUserMessages(null);
    this.startFunctionService.getNotifyStepInProgress().emit(false);
  }

  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }
  

}



// WEBPACK FOOTER //
// ./src/app/broker/sever-employment/sever-employment-notification/sever-employment-notification.component.ts